import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import AdminDashboard from "./pages/AdminDashboard";
// import EmployeeDashboard from './pages/EmployeeDashboard'; 

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />

        {/* ✅ ADD THIS LINE BELOW */}
        <Route path="/portal" element={<AdminDashboard />} />

        <Route path="/" element={<AdminDashboard />} /> {/* Default Home */}
        {/* <Route path="/employee" element={<EmployeeDashboard />} /> */}

        {/* Catch-all route to prevent black screens on refresh */}
        <Route path="*" element={<AdminDashboard />} />
      </Routes>
    </Router>
  );
}

export default App;
